import { memo, useState, useMemo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DateTime } from 'luxon';
import ModalMatricola, { ModalMatricolaFormVM } from './modal';
import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';

interface MatricolaListComponentProps {
  disabled?: boolean;
  value: string;
  onChanges: (values: ModalMatricolaFormVM) => void;
  error?: boolean;
  label?: string;
  id?: string;
  required?: boolean;
  surname: string;
  dateBirth: DateTime | null;
  name: string;
  isSmallSize?: boolean;
  helperText?: string;
}

const MatricolaListComponent = ({
  onChanges,
  required,
  value,
  error,
  label = 'Matricola',
  id = 'matricola-list',
  dateBirth,
  disabled,
  surname,
  name,
  helperText,
  isSmallSize = false,
}: MatricolaListComponentProps): React.ReactElement => {
  const [modalSearch, setModalSearch] = useState<boolean>();

  const initialValues = useMemo(() => {
    if (!dateBirth && !surname && !name) {
      return undefined;
    }
    return {
      birthday: dateBirth,
      surname,
      name,
    };
  }, [dateBirth, surname, name]);

  return (
    <>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={9}>
          <PmiTextField
            label={required ? `${label} *` : label}
            aria-label={label}
            variant="outlined"
            error={error}
            fullWidth
            id={id}
            helperText={helperText ? helperText : undefined}
            value={value || ''}
            disabled
            size={isSmallSize ? 'small' : undefined}
          />
        </Grid>
        <Grid item xs={3}>
          <PmiButton
            variant="outlined"
            color="cdmBrandThird"
            onClick={() => {
              setModalSearch(true);
            }}
            disabled={disabled}
          >
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
      {modalSearch ? (
        <ModalMatricola
          open={modalSearch}
          onClose={(values) => {
            if (values?.matricola) {
              onChanges(values);
            }
            setModalSearch(false);
          }}
          initialValues={initialValues}
        />
      ) : undefined}
    </>
  );
};

MatricolaListComponent.displayName = 'Matricola List component';

const MatricolaList = memo(MatricolaListComponent);

export default MatricolaList as typeof MatricolaListComponent;
